/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum NotificationLevel {
    NoEmails = 0,
    Summary = 50,
    EveryEvent = 100,
}
